import SearchOverview from './SearchOverview'

const ROUTES = [
  SearchOverview
]

export default ROUTES
